document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.glide').forEach(function (el) {
   
    if (el.__glideMounted) return;

    const glide = new Glide(el, {
      type: 'carousel',
      perView: 1,
      /*autoplay: 3000,*/
      hoverpause: false,
      animationDuration: 400
    });

    glide.mount();
    el.__glideMounted = true;
    el.__glideInstance = glide;
  });


   document.querySelectorAll('.glideMembership').forEach(function (el) {
   
    if (el.__glideMounted) return;

    const glideMembership = new Glide(el, {
      type: 'carousel',
      perView: 1,
      hoverpause: false
    });

    glideMembership.mount();
    el.__glideMounted = true;
    el.__glideInstance = glideMembership;
  });



  document.querySelectorAll('.glideT').forEach(function (li) {

  if (li.__glideMounted) return;

  const glideFeatured = new Glide(li, {
  type: 'carousel',
  perView: 8,
  gap: 40,
  autoplay: 2000,
  hoverpause: false,
  animationDuration: 600,


   breakpoints: {
        1199: { perView: 5, gap: 40 },
        874:  { perView: 3, gap: 30 },
        499:  { perView: 1, gap: 20 }
      }
 
  });

  glideFeatured.mount();
  li.__glideMounted = true;
  li.__glideInstance = glideFeatured;
});


document.querySelectorAll('.glideCollection').forEach(function (el) {
  if (el.__glideMounted) return;

  const glideCollection = new Glide(el, {
    type: 'carousel',
    perView: 3,
    gap: 40,
    breakpoints: {
      874: { perView: 2, gap: 40 },
      599: { perView: 1, gap: 30 },
      479: { perView: 1, gap: 20 }
    }
  });

  glideCollection.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideCollection;
});


document.querySelectorAll('.glideReviews').forEach(function (el) {
  if (el.__glideMounted) return;

  const glideReviews = new Glide(el, {
    type: 'carousel',
    perView: 3,
    gap: 40,
    hoverpause: false,
    animationDuration: 600,

    breakpoints: {
      874: { perView: 1, gap: 30 },
      479: { perView: 1, gap: 20 }
    }
  });

  glideReviews.mount();

  // Limit bullets to 4 with click functionality
  const bullets = el.querySelector('.glide__bullets');
  if (bullets) {
    bullets.innerHTML = '';

    for (let i = 0; i < 4; i++) {
      const btn = document.createElement('button');
      btn.className = 'glide__bullet';

      // Click handler to navigate
      btn.addEventListener('click', function () {
        glideReviews.go('=' + (i * 3));
      });

      bullets.appendChild(btn);
    }

    // Highlight active bullet
    const updateActiveBullet = function () {
      const index = glideReviews.index;
      const allBullets = bullets.querySelectorAll('.glide__bullet');
      allBullets.forEach(function (b, idx) {
        b.classList.toggle('glide__bullet--active', idx === Math.floor(index / 3));
      });
    };

    glideReviews.on('move.after', updateActiveBullet);
    updateActiveBullet();
  }

  el.__glideMounted = true;
  el.__glideInstance = glideReviews;
});

document.querySelectorAll('.glideC').forEach(function (el) {
  if (el.__glideMounted) return;


  const glideC = new Glide(el, {
    type: 'carousel',
    perView: 3,
    gap: 40,
    hoverpause: false,
    animationDuration: 600,

    // Glide: max-width (<=)
    breakpoints: {
      986: { perView: 2, gap: 30 }, // <= 986px
      649: { perView: 1, gap: 20 }  // <= 649px
    }
  });

  glideC.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideC;
});


document.querySelectorAll('.glideTeam').forEach(function (el) {
  if (el.__glideMounted) return;


  const glideTeam = new Glide(el, {
    type: 'carousel',
    perView: 6,
    gap: 20,
    hoverpause: false,
    animationDuration: 600,

    // Glide: max-width (<=)
    breakpoints: {
      1199: { perView: 4, gap: 24 },
      874:  { perView: 3, gap: 24 },
      700:  { perView: 2, gap: 24 },
      499:  { perView: 1, gap: 20 }
    }
  });

  glideTeam.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideTeam;
});

document.querySelectorAll('.glideLastA').forEach(function (el) {
  if (el.__glideMounted) return;



  const glideLastA = new Glide(el, {
    type: 'carousel',
    perView: 3,
    gap: 20,
    hoverpause: false,
    animationDuration: 600,

    // Glide: max-width (<=)
    breakpoints: {
      1023: { perView: 2, gap: 20 }, // 660–1023
      659:  { perView: 1, gap: 20 }  // <=659
    }
  });

  glideLastA.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideLastA;
});


document.querySelectorAll('.glideEssen').forEach(function (el) {
  if (el.__glideMounted) return;


  const glideEssen = new Glide(el, {
    type: 'carousel',
    perView: 3,
    gap: 40,
    autoplay: 3000,
    hoverpause: false,
    animationDuration: 600,

    // Glide: max-width (<=)
    breakpoints: {
      1441: { perView: 3, gap: 0 },
      1023: { perView: 2, gap: 0 },
      599:  { perView: 1, gap: 0,peek: 0 }
    }
  });

  glideEssen.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideEssen;
});


document.querySelectorAll('.glideSC').forEach(function (el) {
  if (el.__glideMounted) return;



  const bulletsEl = el.querySelector('.glide__bullets[data-glide-el="controls[nav]"]');
  const mq = window.matchMedia('(max-width: 1199px)');

  function toggleBullets() {
    if (!bulletsEl) return;
    bulletsEl.style.display = mq.matches ? '' : 'none';
  }

 
  toggleBullets();

  const glideSC = new Glide(el, {
    type: 'carousel',
    perView: 5,
    gap: 40,
    hoverpause: false,
    animationDuration: 600,
    breakpoints: {
      1199: { perView: 4, gap: 40 },
      1023: { perView: 3, gap: 40 },
      874:  { perView: 2, gap: 20 },
      499:  { perView: 1, gap: 20 }
    }
  });

  glideSC.on(['mount.after', 'run'], toggleBullets);
  glideSC.mount();

 
  if (mq.addEventListener) mq.addEventListener('change', toggleBullets);
  else mq.addListener(toggleBullets);

  el.__glideMounted = true;
  el.__glideInstance = glideSC;
});


document.querySelectorAll('.glideRelated').forEach(function (el) {
  if (el.__glideMounted) return;


  const glideRelated = new Glide(el, {
    type: 'carousel',
    perView: 3,
    gap: 40,
    autoplay: 4000,
    hoverpause: false,
    animationDuration: 600,

    // Glide: max-width (<=)
    breakpoints: {
      1023: { perView: 2, gap: 20 },
      599:  { perView: 1, gap: 20 }
    }
  });

  glideRelated.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideRelated;
});

document.querySelectorAll('.glideCatego').forEach(function (el) {
  if (el.__glideMounted) return;


  const bulletsEl = el.querySelector('.glide__bullets[data-glide-el="controls[nav]"]');
  const mq = window.matchMedia('(max-width: 870px)');

   function toggleBullets() {
    if (!bulletsEl) return;
    bulletsEl.style.display = mq.matches ? '' : 'none';
  }

 
  toggleBullets();
 

  const glideCatego = new Glide(el, {
    type: 'carousel',
    perView: 4,
    gap: 1,
    hoverpause: false,
    animationDuration: 600,

    // Glide uses max-width (<=)
    breakpoints: {
      874: { perView: 1, gap: 30 }, // <=874px (matches your 320/480 behavior)
      479: { perView: 1, gap: 20 }  // <=479px (optional, matches your 320 gap 20)
    }
  });

  glideCatego.on(['mount.after', 'run'], toggleBullets);
  glideCatego.mount();

  if (mq.addEventListener) mq.addEventListener('change', toggleBullets);
  else mq.addListener(toggleBullets);

  el.__glideMounted = true;
  el.__glideInstance = glideCatego;
});



document.querySelectorAll('.glideEditor').forEach(function (el) {
  if (el.__glideMounted) return;

  const slidesCount = el.querySelectorAll('.glide__slide').length;
  const glideType = slidesCount <= 3 ? 'slider' : 'carousel';

  const glideEditor = new Glide(el, {
    type: glideType,
    perView: Math.min(3, slidesCount),
    gap: 40,
    hoverpause: false,
    animationDuration: 600,
    rewind: slidesCount > 3,

    breakpoints: {
      1023: { perView: Math.min(2, slidesCount), gap: 30 },
      874:  { perView: Math.min(2, slidesCount), gap: 30 },
      600:  { perView: 1, gap: 30 },
      319:  { perView: 1, gap: 20 }
    }
  });

  glideEditor.mount();
  el.__glideMounted = true;
  el.__glideInstance = glideEditor;

  // Aplicar estilos dinámicos según cantidad de slides
  const items = el.querySelectorAll('.item-slide-most-popular');
  
  if (slidesCount === 1) {
    items.forEach(item => {
      item.style.width = '100%';
      item.style.maxWidth = '440px';
      item.style.margin = '0 auto';
    });
  } else if (slidesCount === 2) {
    items.forEach(item => {
      item.style.width = '100%';
      item.style.maxWidth = '550px';
    });
  }

  // Función para manejar la visibilidad de los bullets según el tamaño de pantalla
  function handleBulletsVisibility() {
    const bullets = el.querySelector('.glide__bullets');
    const arrows = el.querySelector('.glide__arrows');
    const windowWidth = window.innerWidth;

    if (slidesCount <= 3) {
      // Ocultar arrows siempre si hay 3 o menos slides
      if (arrows) arrows.style.display = 'none';
      
      // Mostrar bullets solo en móvil (600px o menos)
      if (bullets) {
        bullets.style.display = windowWidth <= 600 ? 'flex' : 'none';
      }
    } else {
      // Si hay más de 3 slides, mostrar arrows siempre
      if (arrows) arrows.style.display = 'block';
      
      // Bullets visibles solo en móvil
      if (bullets) {
        bullets.style.display = windowWidth <= 600 ? 'flex' : 'none';
      }
    }
  }

  // Ejecutar al cargar
  handleBulletsVisibility();

  // Ejecutar al redimensionar la ventana
  window.addEventListener('resize', handleBulletsVisibility);
});




});
